export default "__VITE_ASSET__Cm65gqsr__"